import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from 'reactstrap';

interface ResendKycModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleSendMail: () => void;
  handleSendWhatsapp: () => void;
  guestEmail?: string;
  guestPhone?: string;
}

const ResendKycModal: React.FC<ResendKycModalProps> = ({
  isOpen,
  onClose,
  handleSendMail,
  handleSendWhatsapp,
  guestEmail,
  guestPhone,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} centered>
    <ModalHeader toggle={onClose}>Reenviar formulario KYC</ModalHeader>
    <ModalBody>
      <Row className="mb-3" style={{ fontSize: '1rem' }}>
        <Col xs={12} md={12} className="mb-2">
          <strong>Email:</strong>{' '}
          {guestEmail || <span className="text-muted">No disponible</span>}
        </Col>
        <Col xs={12} md={12} className="mb-2">
          <strong>Teléfono:</strong>{' '}
          {guestPhone || <span className="text-muted">No disponible</span>}
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Button
            className="btn-lg w-100"
            color="primary"
            onClick={handleSendMail}
          >
            Enviar por correo
          </Button>
        </Col>
        <Col md={12} className="mt-2">
          <Button
            className="btn-lg w-100"
            color="success"
            onClick={handleSendWhatsapp}
          >
            Enviar por WhatsApp
          </Button>
        </Col>
      </Row>
    </ModalBody>
  </Modal>
);

export default ResendKycModal;
